import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'folderTemplate';

const folderTemplateService = {
  getData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  getTemplates: () => {
    return request({
      resource: `${baseURL}/templates`,
    });
  },

  getDeafultTemplateItems: () => {
    return request({
      resource: `${baseURL}/defaultTemplateItems`,
    });
  },

  createData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateData: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteData: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};

export default folderTemplateService;
